import Vue from "vue";
import Component from "vue-class-component";
import { format } from "date-fns";
import * as DateUtils from "@/utils/dateUtils";

@Component
export default class DateFormatter extends Vue {
  /**
   * Formats the raw date received from the api to DD/MM/YYYY HH:mm:ss date string
   * @param dateString
   */
  public formatDateFromAPI(
    dateString: number,
    dateAndTime: boolean = true,
    includeTimezone: boolean = false
  ): string {
    return DateUtils.formatDateFromAPI(
      dateString,
      dateAndTime,
      includeTimezone
    );
  }

  /**
   * Formats the raw date received from the api to MMM DD YYYY date string
   * @param dateString
   */
  public formatDatetoReadableDate(
    dateString: number,
    includeTime: boolean = true
  ): string {
    return format(
      Number(dateString) * 1000,
      includeTime ? "MMM dd, yyyy HH:mm" : "MMM dd, yyyy"
    );
  }

  /**
   * Converts seconds to days
   * @param seconds
   */
  public formatSecondsToDays(seconds: number): number {
    return Math.ceil(seconds / (3600 * 24));
  }

  /**
   * Converts seconds to minutes, hours, days, months or years
   * @param seconds
   */
  public formatSecondsToMinutesHoursOrDays(seconds: number): string {
    return DateUtils.formatSecondsToMinutesHoursOrDays(seconds);
  }

  /**
   * Converts seconds to minutes, hours or days
   * @param seconds
   */
  public formatSecondsUpToDays(seconds: number): string {
    return DateUtils.formatSecondsUpToDays(seconds);
  }

  /**
   * 📆 Converts seconds to years + months + days
   * @param seconds
   */
  public formatSecondsToExactTimeFromYearsToDays(seconds: number): string {
    return DateUtils.formatSecondsToExactTimeFromYearsToDays(seconds);
  }
}
